import {inject, Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {BsModalService} from 'ngx-bootstrap/modal';
import {take} from 'rxjs';
import {CheckoutModalComponent} from 'src/app/components/checkout-modal/checkout-modal.component';
import {ConfirmationModalComponent} from 'src/app/components/confirmation/confirmation-modal.component';
import {CourseService} from './course.service';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CheckoutModalService {
  private dialog = inject(MatDialog);
  private modalService = inject(BsModalService);
  private courseService = inject(CourseService);
  private router = inject(Router);

  private loading = false;

  buyCourse(course, isDiscover: boolean = false) {
    const courseId = isDiscover ? course.courseType : course.webAppId;

    if (['PRIVATE', 'SPORT'].includes(courseId)) {
      this.router.navigate([`/course/${courseId}/welcome`]);
      return;
    }

    if (['INSTRUMENT', 'COMMERCIAL'].includes(courseId)) {
      this.router.navigate([`/course/${courseId}/marketing`]);
      return;
    }

    let courseForCheckout = course;

    if (isDiscover) {
      courseForCheckout = {
        webAppId: course.courseType,
        longName: course.title,
        webPurchaseUrl: course.purchaseLink,
        shoppingCartImageUrl: course.thumbnail_url,
        price: course.price
      };
    }

    this.openCheckout(courseForCheckout);
  }

  openCheckout(course) {
    if (this.loading) {
      return;
    }

    this.loading = true;

    this.courseService
      .getCoursePrice(course.webAppId)
      .then((val) => {
        const coursePrice =
          '$' + (val.discountPrice !== null ? val.discountPrice : val.price);

        this.loading = false;
        this.openCheckoutModal(course, coursePrice);
      })
      .catch((error) => {
        console.log('Error fetching course price:', error);
        this.loading = false;
        this.openCheckoutModal(course, course.price, true);
      });
  }

  openCheckoutModal(course, price, error = false) {
    let courseName = course.longName;

    if (['PRIVATE', 'SPORT', 'RECREATION'].includes(course.webAppId)) {
      courseName = `Sporty's Learn to Fly Course`;
    }
    if (course.webAppId === 'COMMERCIAL') {
      courseName = `Sporty's Commercial Pilot Course`;
    }
    if (['CFI_AI', 'CFI_I', 'CFI_FOI'].includes(course.webAppId)) {
      courseName = `Sporty's Flight Instructor (CFI) Course`;
    }
    const dialogRef = this.dialog.open(CheckoutModalComponent, {
      data: {
        courseId: course.webAppId,
        courseName: courseName,
        courseWebPurchaseUrl: course.webPurchaseUrl,
        courseShoppingCartImagelUrl: course.shoppingCartImageUrl,
        error: error,
        price: price
      },
      disableClose: true,
      closeOnNavigation: true,
      panelClass: 'checkout-modal-dialog'
    });

    dialogRef.backdropClick().subscribe(() => {
      if (dialogRef.componentInstance.paymentComplete()) {
        this.handleDialogClose(course, dialogRef);
        return;
      }

      const modal = this.modalService.show(ConfirmationModalComponent, {
        initialState: {
          message:
            'Are you sure you want to close this modal and lose your checkout progress?',
          warningMessage: null,
          yesLabel: 'Yes',
          noLabel: 'No',
          primaryButton: 'yes'
        },
        class: 'rounded-modal '
      });

      const sub = this.modalService.onHide.pipe(take(1)).subscribe((value) => {
        if (modal.content.response) {
          this.handleDialogClose(course, dialogRef);
        }
        modal.hide();
      });
    });
  }

  private handleDialogClose(course, dialogRef): void {
    dialogRef.close();
    if (course.webAppId !== 'FIRC_ACR' && dialogRef.componentInstance.paymentComplete()) {
      this.router.navigate(['/course', course.webAppId]);
    }
  }
}
